import image1 from "../assets/uiimg1.png";
import image2 from "../assets/uiimg2.png";

export const uiData = [
  {
    image: image1,
    review:
      "UI design for Robotic Association of Technology faculty in Rajarata University. Modern single page design and simple looking.",
    name: "ROST Website",
    used: "Figma / Illustrator",
    link: "https://www.figma.com/design/8oq7khU72utLE53wPteyrT/ROST-Site?node-id=0-1&t=sYoG8kibbFcauPPO-1",
  },
  {
    image: image2,
    review:
      "Simple UI/UX design for Q&A app like stack overflow. In this prototyping is also created by myself",
    name: "Q&A App",
    used: "Figma",
    link: "https://www.figma.com/design/TK8bDkc86cof16Wrt5b7ch/Mobile-App?node-id=0-1&t=uH55OnbOKWEOnLIm-1",
  },
];
